import React from 'react';
import { BriefOverviewProductFragment } from './BriefOverview/BriefOverview.generated';

export type paymentSource = 'paid' | 'fully-funded' | undefined;

export interface Order {
    id: string;
    items: Array<{ id: string }> | null;
}

export interface BriefContextValues {
    brief: {
        id: string;
        designers: { id: string }[];
        designersWithSource: { source: string }[];
    };
    product?: BriefOverviewProductFragment | null;
    order?: Order | null;
    paymentSource?: paymentSource;
    schema: string;
    totalAllowableDesigners: number;
    disableContacts: boolean;
    noPaymentRequiredHeading?: string;
}

export const BriefContext = React.createContext<BriefContextValues>({
    brief: { id: '12341234', designers: [], designersWithSource: [] },
    totalAllowableDesigners: 5,
    disableContacts: false,
    schema: '',
});
